export default __webpack_public_path__ + "src/assets/icn-question.41c5dc9ff9a0380c096e813360e2c93f.svg";